import {Outlet, createFileRoute} from "@tanstack/react-router";

import {routeMessages} from "../../../../messages/routes.messages";

export const Route = createFileRoute("/_app/engineering/materials")({
  component: () => <Outlet />,
  staticData: {
    meta: {
      labelDescriptor: routeMessages.materials,
      moduleDescriptor: routeMessages.engineering,
      nav: {order: 4, visible: true},
    },
  },
});
